import PageLayer from "@Layouts/views/PageLayer";
import UsersLayer from "@DataPages/components/Users/UsersLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Users
import { ReactComponent as Icon } from "@/assets/icons/header/dataPages/UsersIcon.svg";

export default function Users() {
	return (
		<PageLayer
			title="Users"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon className="text-[var(--light-blue-color)] !text-[27px]" viewBox="0 -4 22 22" component={Icon} />
				</Stack>
			}
		>
			<UsersLayer />
		</PageLayer>
	);
}
